import React from 'react';
import Particles from "react-tsparticles";
import particlesConfig from './config';

export default function ParticalesBackground() {
  return (
    <div style={{zIndex: '-1'}}>
        <Particles params={particlesConfig} />
    </div>
  )
}
